import { RawDataTimeSeries } from '@/components/RawData';

export interface Props {
  uniqueSymbol: string;
  reportingCurrencyISO: string;
  reportingUnit: string;
  lastEarningsUpdate: number;
  companyShortName: string;
  pastDebtAndEquityData: { dateKey: number; data: number[] }[];
}

const pastDebtHeaders = [
  'Total Equity',
  'Total Debt',
  'Cash & Short Term Investments',
];

const HistoricalDebtEquityRawData = ({
  uniqueSymbol,
  reportingCurrencyISO,
  reportingUnit,
  lastEarningsUpdate,
  companyShortName,
  pastDebtAndEquityData,
}: Props) => (
  <div>
    <p>
      {`All data from ${companyShortName} Company Filings, last reported ${new Date(
        lastEarningsUpdate
      ).toLocaleDateString()}`}
    </p>
    <RawDataTimeSeries
      uniqueSymbol={uniqueSymbol}
      title="Past Debt and Equity Data"
      reportingCurrencyISO={reportingCurrencyISO}
      reportingUnit={reportingUnit}
      numberPrecision={2}
      tableHeaderDescriptions={pastDebtHeaders}
      tableData={pastDebtAndEquityData}
    />
  </div>
);

export default HistoricalDebtEquityRawData;
